import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import '../../App.css';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],  // Font sizes (h1, h2, h3, normal)
    ['bold', 'italic', 'underline'],    // Text formatting
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],  // Lists
    ['clean']                           // Remove formatting
  ]
};

const formats = [
  'header',
  'bold', 'italic', 'underline',
  'list', 'bullet'
];

/**
 * Text section component for reflection editing/display with WYSIWYG editor
 */
function TextSection({ isEditMode, textContent, isActive, onToggle, onFieldChange, isDisabled, isRecordingActive, hideHeader }) {
  return (
    <div className="reflection-section">
      {!hideHeader && (
        <div
          className={`reflection-section-header ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
          onClick={onToggle}
          style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
        >
          <div className="section-header-left">
            <span>Text</span>
            {!textContent && (
              <span className="no-content-indicator">(no text)</span>
            )}
          </div>
          <span className="section-toggle">{isActive ? '▼' : '▶'}</span>
        </div>
      )}
      {isActive && (
        <div className="reflection-section-content">
          {isEditMode ? (
            <ReactQuill
              theme="snow"
              value={textContent || ''}
              onChange={(value) => onFieldChange('text_content', value)}
              modules={modules}
              formats={formats}
              placeholder="Add text response..."
              readOnly={isRecordingActive}
              style={{
                opacity: isRecordingActive ? 0.6 : 1
              }}
            />
          ) : (
            textContent ? (
              <ReactQuill
                theme="bubble"
                value={textContent}
                readOnly={true}
              />
            ) : (
              <p className="no-content">No text content</p>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default TextSection;
